import Form from 'react-bootstrap/Form'

interface CheckboxInterface {
  id: string|number,
  type: 'checkbox'|'radio',
  className?: string,
  isValid?: boolean,
  label: string,
  labelClassname?: string,
  inputClassname?: string,
  checked: boolean,
  feedbackIsValid?: boolean,
  feedbackTxt?: string,
  onChange: Function,
  disabled?: boolean,
}

const Checkbox = ({
  id,
  type,
  className,
  isValid = false,
  label,
  labelClassname,
  inputClassname,
  checked = false,
  feedbackIsValid = true,
  feedbackTxt,
  onChange,
    disabled = false,
}: CheckboxInterface) => (
  <Form.Check
    type={type}
    id={id}
    className={`custom-control custom-checkbox ${className || ''}`}>
    <Form.Check.Input
      type={type}
      isValid={isValid}
      className={`custom-control-input ${inputClassname || ''}`}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    <Form.Check.Label
      className={`custom-control-label ${labelClassname || ''}`}>
      {label}
    </Form.Check.Label>
    {(feedbackTxt && (
      <Form.Control.Feedback type={(feedbackIsValid && 'valid') || 'invalid'}>
        {feedbackTxt}
      </Form.Control.Feedback>
    )) || <></>}
  </Form.Check>
)

export default Checkbox
